import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useRequiredChartPlugins } from '../plugins/usePlugins.js';
import { ChartContainer } from '../styled.js';
const BarChart = React.forwardRef(function BarChart(props, ref) {
    const { 'data-testid': testId, ...chartProps } = props;
    useRequiredChartPlugins(chartProps.options);
    return (_jsx(ChartContainer, { "data-testid": testId, style: { height: chartProps.height ? `${chartProps.height}px` : undefined }, children: _jsx(Bar, { ref: ref, ...chartProps }) }));
});
export default BarChart;
